import { useEffect, useState } from 'react';
import { fetchDealerOnePageReport, fetchZonesPOReports, fetchZonePartiesPOReports } from 'Service/ApiService';
const MONTH_NUMBERS = [4,5,6,7,8,9,10,11,12,1,2,3];
const MONTHS = ['APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC','JAN','FEB','MAR'].map((m,i)=>({value:MONTH_NUMBERS[i],label:`${String(i+1).padStart(2,'0')} ${m}`}));
const EMPTY_REPORT_DATA = {
  party: null,
  fiscalYears: [],
  products: [],
  months: [],
  outstanding: [],
  pendingSummary: [],
  pendingDetails: [],
  pendingPagination: { page: 1, pageSize: 100, totalRecords: 0, totalPages: 0 }
};
export default function DealerOnePageReportController() {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const [areaOptions,setAreaOptions]=useState([]), [partyOptions,setPartyOptions]=useState([]), [selectedArea,setSelectedArea]=useState([]), [selectedParty,setSelectedParty]=useState([]), [selectedMonth,setSelectedMonth]=useState(MONTHS);
  const [hasAssignedCustomers,setHasAssignedCustomers]=useState(false);
  const [reportData,setReportData]=useState(null), [loading,setLoading]=useState(false), [error,setError]=useState('');
  const [filtersLoading,setFiltersLoading]=useState(true), [filtersReady,setFiltersReady]=useState(false);
  const [pendingPage,setPendingPage]=useState(1);
  useEffect(()=>{ let active=true; setFiltersLoading(true); Promise.all([fetchZonesPOReports(user.userCode,'collection'),fetchZonePartiesPOReports(user.userCode,{type:'outstanding'})]).then(([z,p])=>{if(!active)return; const areas=z?.zones?.map((x,i)=>({label:x.region?.trim()||'(NO REGION)',value:`${x.zoneCode}_${i}`,zoneCode:x.zoneCode}))||[]; const parties=p?.parties?.map(x=>({label:`${x.partyName?.trim()||''} - ${x.city?.trim()||''} - ${x.partyCode?.trim()||''}`,value:x.partyCode}))||[]; setHasAssignedCustomers(parties.length > 0); const normalizedUserType=String(user.userTypeId||user.userType||'').trim().toUpperCase(); if(['DEALER','DIST','DISTRIBUTOR'].includes(normalizedUserType) && user.userCode && !parties.some(x=>String(x.value)===String(user.userCode))){parties.push({label:`${user.displayName||user.userName||user.userCode} - ${user.userCode}`,value:String(user.userCode)});} setAreaOptions(areas);setPartyOptions(parties);setSelectedArea(areas);setSelectedParty(parties);}).catch(e=>console.error('Dealer dropdown load error:',e)).finally(()=>{if(active){setFiltersLoading(false);setFiltersReady(true);}}); return()=>{active=false};},[user.userCode]);
  useEffect(()=>{ setPendingPage(1); },[selectedArea,selectedParty,selectedMonth]);
  useEffect(()=>{
    let active=true;
    if(!user.userCode||!filtersReady)return undefined;

    if(hasAssignedCustomers && selectedParty.length===0){
      setReportData(EMPTY_REPORT_DATA);
      setError('');
      setLoading(false);
      return undefined;
    }

    setLoading(true);
    setError('');
    setReportData(null);
    fetchDealerOnePageReport({
      userCode:user.userCode,
      area:selectedArea.map(x=>x.zoneCode||x.value).join(','),
      partyCode:hasAssignedCustomers?selectedParty.map(x=>x.value).join(','):user.userCode,
      partyFilterApplied:hasAssignedCustomers,
      month:selectedMonth.map(x=>x.value).join(','),
      pendingPage
    }).then(response=>{
      if(!active)return;
      if(response?.success===false)throw new Error(response.message||'Unable to load report');
      setReportData(response?.data||null);
    }).catch(e=>{
      if(active)setError(e.message||'Unable to load report');
    }).finally(()=>{
      if(active)setLoading(false);
    });
    return()=>{active=false};
  },[user.userCode,filtersReady,selectedArea,selectedParty,selectedMonth,pendingPage,hasAssignedCustomers]);
  return {areaOptions,partyOptions,monthOptions:MONTHS,selectedArea,setSelectedArea,selectedParty,setSelectedParty,selectedMonth,setSelectedMonth,reportData,loading,filtersLoading,error,pendingPage,setPendingPage,loggedInUser:user};
}
